module.exports = __webpack_public_path__ + "static/media/dark-swap-round.fc8a5c6e.svg";